import React from 'react';
import { DishCard } from './food/DishCard';
import { ApparelCard } from './retail/ApparelCard';
import { PerfumeCard } from './retail/PerfumeCard';
import { VehicleCard } from './vehicles/VehicleCard';
import { PropertyCard } from './property/PropertyCard';
import { FurnitureCard } from './furniture/FurnitureCard';
import { Dish } from '../data/food';
import { Apparel, Perfume } from '../data/retail';
import { Furniture } from '../data/furniture';
export interface ListingCardProps {
  id: string;
  title: string;
  price: string;
  location: string;
  images: string[];
  specs: {
    label: string;
    value: string;
  }[];
  matchScore: number;
  sellerType: 'Dealer' | 'Individual' | 'Verified Business';
  isSaved?: boolean;
  selected?: boolean;
  onToggleSelect?: () => void;
  /** Present on food results — turns the card into something orderable. */
  dish?: Dish;
  /** Present on clothing results. */
  apparel?: Apparel;
  /** Present on fragrance results. */
  perfume?: Perfume;
  /** Present on furniture results. */
  furniture?: Furniture;
  /** Chooses between the two spec-led cards. Defaults to vehicle. */
  sector?: 'vehicle' | 'property' | 'electronics';
  /**
   * Set when the card is one of many from a single merchant (a brand's own
   * menu), where the seller badge is redundant and the grid runs denser.
   */
  compact?: boolean;
}

/**
 * Routes a result to the card built for its sector. Every sector reads
 * differently — a dish is configured, a garment is sized, a fragrance is
 * chosen by note, a car is compared on condition, a home is chosen on place —
 * so there is no single "listing card", only a dispatcher.
 */
export function ListingCard(props: ListingCardProps) {
  if (props.dish) return <DishCard {...props} dish={props.dish} data-id="element-2593" data-mp="2iwszj1p6h8ub" />;
  if (props.apparel) return <ApparelCard {...props} apparel={props.apparel} data-id="element-2594" data-mp="2mzpp5cd4y57r" />;
  if (props.perfume) return <PerfumeCard {...props} perfume={props.perfume} data-id="element-2595" data-mp="2mxld27531zwe" />;
  if (props.furniture) return <FurnitureCard {...props} furniture={props.furniture} data-id="element-2596" data-mp="2rwg4fxh48ws4" />;
  if (props.sector === 'property') return <PropertyCard {...props} data-id="element-2597" data-mp="ru6u28q9qs8n" />;
  return <VehicleCard {...props} data-id="element-2598" data-mp="nv7rgus0f7kd" />;
}